export default {
  title: 'MAXHUB Activate',
  instruction: 'Please properly fill in user and Dealer information which could affect after-sale service related issues',
  dealername: 'Dealer\'s Name',
  dealerplaceholder: 'Dealer\'s Name',
  companyname: 'Company Name',
  companyplaceholder: 'Company Name',
  tele: 'Contact Information',
  teleplaceholder: 'Cellphone',
  district: 'Area select',
  distplaceholder: 'Area information',
  address: 'Detailed address',
  addrplaceholder: 'Detailed address',
  activebtn: 'Get the activation code',
  confirmbtn: 'Confirm',
  cancelbtn: 'Cancel',
  dialogmessage: 'The cellphone format is wrong, please re-input again',
  dialogbtn: 'Confirm',
  errortitle: 'Can not open',
  errorinfo1: 'Try network check',
  errorinfo2: 'Hotline 400-168-9545',
  nosn: 'This device can not be activated since no SN',
  activepagetitle: 'Activation code',
  activepagehint: 'Please input activation code to activate device',
  finish: 'Complete',
  search: 'Search for nearby locations'
};



// WEBPACK FOOTER //
// ./src/i18n/_en.js